import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonAction, FileView, RowActionEvent } from '../../models';

@Component({
    selector: '[file-loaded]',
    templateUrl: './file.component.html',
    styleUrls: ['./file.component.scss']
})
export class FileComponent {

    @Input() fileView: FileView;
    @Input() disableAllButtonsRow: boolean;
    @Input() loadSuccess?: boolean;
    @Output() rowFileClicked: EventEmitter<RowActionEvent> = new EventEmitter();

    typeButton = ButtonAction;

    rowClicked(btn: ButtonAction) {
        let event: RowActionEvent = {
            action: btn
        }
        this.rowFileClicked.emit(event);
    }
}
